export default __webpack_public_path__ + "static/media/background-top-right.03d860ec.png";